import { render, staticRenderFns } from "./NewClassroom.vue?vue&type=template&id=5c8dd43d&scoped=true"
import script from "./NewClassroom.vue?vue&type=script&lang=js"
export * from "./NewClassroom.vue?vue&type=script&lang=js"
import style0 from "./NewClassroom.vue?vue&type=style&index=0&id=5c8dd43d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8dd43d",
  null
  
)

export default component.exports